<template>
<span>
  <sup style="text-decoration: underline; padding: 0 3px"
    v-if="sources"
    @click.prevent="gotoSource(source)"
    class="cursor-pointer text-xs pl-2 pr-2 mini-source"
    v-for="(source, source_i) of sources"
    :key="source_i"
  >{{ source.source_id }}</sup>
</span>
</template>

<style lang="scss" scoped>
.mini-source {
  display: inline-block;
}
</style>

<script>
import {EventBus} from '@/event-bus.js'

export default {
  'name': 'mini-source',
  props: ['sources'],
  methods: {
    gotoSource (source) {
      EventBus.$emit('source:click', source)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/covid19/MiniSourceLink.vue